import * as THREE from 'three';

// Shading styles that keep each material's colour texture: 'normal' (as exported), 'matcap', 'toon'.
let matcapTex = null;
let toonRamp = null;

function getMatcap() {
  if (matcapTex) return matcapTex;
  const c = document.createElement('canvas');
  c.width = c.height = 256;
  const g = c.getContext('2d');
  g.fillStyle = '#2a2018';
  g.fillRect(0, 0, 256, 256);
  const grad = g.createRadialGradient(96, 84, 8, 128, 128, 128);
  grad.addColorStop(0, '#ffffff');
  grad.addColorStop(0.35, '#e9e2d8');
  grad.addColorStop(0.75, '#9a8f84');
  grad.addColorStop(1, '#3a3028');
  g.fillStyle = grad;
  g.beginPath();
  g.arc(128, 128, 128, 0, Math.PI * 2);
  g.fill();
  matcapTex = new THREE.CanvasTexture(c);
  matcapTex.colorSpace = THREE.SRGBColorSpace;
  return matcapTex;
}

function getToonRamp() {
  if (toonRamp) return toonRamp;
  toonRamp = new THREE.DataTexture(new Uint8Array([70, 70, 70, 255, 150, 150, 150, 255, 215, 215, 215, 255]), 3, 1);
  toonRamp.minFilter = THREE.NearestFilter;
  toonRamp.magFilter = THREE.NearestFilter;
  toonRamp.needsUpdate = true;
  return toonRamp;
}

function convert(orig, mode) {
  const common = {
    name: orig.name, map: orig.map, color: orig.color?.clone(), transparent: orig.transparent, opacity: orig.opacity,
    alphaTest: orig.alphaTest, side: orig.side, alphaMap: orig.alphaMap
  };
  const mat = mode === 'matcap'
    ? new THREE.MeshMatcapMaterial({ ...common, matcap: getMatcap() })
    : new THREE.MeshToonMaterial({ ...common, gradientMap: getToonRamp() });
  mat.userData.__orig = orig;
  return mat;
}

const original = (m) => m?.userData?.__orig || m;

// Swap every mesh material for the chosen style; originals are kept so 'normal' restores them.
export function applyShading(scene, mode) {
  scene.traverse((o) => {
    if (!o.isMesh || o.userData.__isOutline) return;
    const swap = (m) => {
      const orig = original(m);
      if ((mode !== 'matcap' && mode !== 'toon') || !orig?.color) return orig;
      const cache = orig.userData.__shaded || (orig.userData.__shaded = {});
      cache[mode] = cache[mode] || convert(orig, mode);
      cache[mode].map = orig.map;
      cache[mode].color.copy(orig.color);
      return cache[mode];
    };
    o.material = Array.isArray(o.material) ? o.material.map(swap) : swap(o.material);
  });
}

// Every material behind a mesh: the exported one plus any shaded copies of it.
export function eachMaterial(scene, fn) {
  scene.traverse((o) => {
    if (!o.isMesh || o.userData.__isOutline) return;
    (Array.isArray(o.material) ? o.material : [o.material]).forEach((m) => {
      const orig = original(m);
      if (!orig) return;
      fn(orig);
      Object.values(orig.userData.__shaded || {}).forEach(fn);
    });
  });
}
